/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Cell', {
    staticClass: "check-box-com"
  }, [_c('div', {
    staticClass: "check-img-body",
    attrs: {
      "slot": "icon"
    },
    on: {
      "click": _vm.onChange
    },
    slot: "icon"
  }, [_vm.checked ? [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/checksquare32_32@3x.png"
    }
  })] : [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/nochecksquare32_32@3x.png"
    }
  })]], 2), _c('div', {
    staticClass: "cell-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };